"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _DomainServices = require("./services/DomainServices");
var _DomainStatus = require("./constants/DomainStatus");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AddToCartButton = ({
  apiKey,
  language,
  buttonText,
  eid,
  id,
  buttonDesign = 'primary',
  isDisabled = false,
  ariaLabel,
  classNames,
  domain,
  trackingCode,
  urlOverride,
  plid,
  basketId,
  renewalText,
  premiumPriceDisplay,
  unavailableText,
  verifyingText,
  successText,
  showFreeIndicator,
  showFreeText,
  hasSalePrice,
  listPriceDisplay,
  salePriceDisplay,
  failureCallback,
  successCallback,
  unavailableCallback,
  numberOfTerms
}) => {
  const [status, setStatus] = (0, _react.useState)(_DomainStatus.STATUS.DEFAULT);
  const [, setPayload] = (0, _react.useState)({});
  const addClick = () => {
    setStatus(_DomainStatus.STATUS.VERIFYING);
    const params = {
      fqdn: domain.Fqdn,
      itemTrackingCode: trackingCode || '',
      plid,
      basketId,
      apiKey,
      numberOfTerms
    };
    const callSapi = async () => {
      try {
        const response = await (0, _DomainServices.postToSapi)(params, urlOverride);
        if (response?.cartCount > 0) {
          setStatus(_DomainStatus.STATUS.SUCCESS);
          setPayload(response.data);
          successCallback?.(response, [domain.Fqdn], domain);
        } else if (response.status === 422 && response.message === 'Domain is unavailable.') {
          setStatus(_DomainStatus.STATUS.UNAVAILABLE);
          setPayload({});
          unavailableCallback?.(domain);
        } else {
          setStatus(_DomainStatus.STATUS.ERROR);
          failureCallback?.(response);
        }
      } catch (e) {
        setStatus(_DomainStatus.STATUS.ERROR);
        failureCallback?.(e);
      }
    };
    callSapi();
  };
  let renderContent;
  if (status === _DomainStatus.STATUS.VERIFYING) {
    renderContent = /*#__PURE__*/_react.default.createElement("h6", {
      className: "headline-primary",
      "data-testid": "headline-verifying"
    }, verifyingText || language.verifyingAvailability);
  } else if (status === _DomainStatus.STATUS.UNAVAILABLE) {
    renderContent = /*#__PURE__*/_react.default.createElement("h6", {
      className: "headline-primary unavailable",
      "data-testid": "headline-unavailable"
    }, unavailableText || language.domainFailedAvailCheck);
  } else if (status === _DomainStatus.STATUS.SUCCESS) {
    renderContent = /*#__PURE__*/_react.default.createElement("h6", {
      className: "headline-primary",
      "data-testid": "headline-success"
    }, successText || language.successText);
  } else {
    let priceBlock = /*#__PURE__*/_react.default.createElement("span", {
      className: "dpp-price text-primary-o"
    }, salePriceDisplay);
    if (hasSalePrice || showFreeIndicator) {
      priceBlock = /*#__PURE__*/_react.default.createElement("div", {
        className: "price-block"
      }, showFreeIndicator ? /*#__PURE__*/_react.default.createElement("span", {
        className: "dpp-price text-primary-o"
      }, showFreeText) : priceBlock, /*#__PURE__*/_react.default.createElement("small", null, /*#__PURE__*/_react.default.createElement("del", null, listPriceDisplay)));
    }

    // Price Display for Premium names
    if (premiumPriceDisplay) {
      priceBlock = /*#__PURE__*/_react.default.createElement("div", {
        className: "price-block"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "dpp-price text-primary-o"
      }, premiumPriceDisplay, /*#__PURE__*/_react.default.createElement("span", {
        className: "renewal-price"
      }, "+ ", listPriceDisplay, "/yr")), /*#__PURE__*/_react.default.createElement("span", {
        className: "renewal-text"
      }, listPriceDisplay, renewalText || language.renewalText));
    }
    renderContent = /*#__PURE__*/_react.default.createElement("div", null, priceBlock, /*#__PURE__*/_react.default.createElement(_button.default, {
      id: id,
      "data-eid": `${eid}buy.click`,
      design: buttonDesign || 'primary',
      className: classNames,
      onClick: addClick,
      disabled: isDisabled,
      text: buttonText || language.buyButtonText,
      "aria-label": ariaLabel,
      "data-testid": "add-to-cart-button"
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "buy-btn-wrap"
  }, renderContent);
};
AddToCartButton.propTypes = {
  language: _propTypes.default.object.isRequired,
  apiKey: _propTypes.default.string.isRequired,
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  buttonDesign: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  domain: _propTypes.default.object.isRequired,
  eid: _propTypes.default.string.isRequired,
  isc: _propTypes.default.string,
  isDisabled: _propTypes.default.bool,
  plid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  redirectToVCart: _propTypes.default.bool,
  skipAvailCheck: _propTypes.default.bool,
  trackingCode: _propTypes.default.string,
  urlOverride: _propTypes.default.string,
  vcartOptions: _propTypes.default.object,
  basketId: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  classNames: _propTypes.default.string,
  renewalText: _propTypes.default.string,
  premiumPriceDisplay: _propTypes.default.string,
  unavailableText: _propTypes.default.string,
  verifyingText: _propTypes.default.string,
  successText: _propTypes.default.string,
  showFreeIndicator: _propTypes.default.bool,
  showFreeText: _propTypes.default.string,
  hasSalePrice: _propTypes.default.bool,
  listPriceDisplay: _propTypes.default.string,
  salePriceDisplay: _propTypes.default.string,
  failureCallback: _propTypes.default.func,
  successCallback: _propTypes.default.func,
  unavailableCallback: _propTypes.default.func,
  numberOfTerms: _propTypes.default.number
};
var _default = exports.default = AddToCartButton;